import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]
  changeUrl(event) {
    const form = this.formTarget
    form.action = event.params.url
  }
}
